// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"25747dbb","351":"404bceea","401":"d75c08c2","782":"67aa63c3","845":"523d8eee"}[chunkId] + ".chunk.js";
};